.root {
  background-color: light-dark(var(--mantine-color-primary-light), var(--mantine-color-primary-light));
}

.remove {
  color: light-dark(var(--mantine-color-primary-filled), var(--mantine-color-primary-filled));
}